module.exports = __webpack_public_path__ + "img/cand-qualified.750974dd.svg";